// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QxqO","field":"styles_field__18WUF","fieldCol":"styles_fieldCol__JVaVd","diffCol":"styles_diffCol__1RLo4","diff":"styles_diff__CkIO_"};